/**
 * @file 団委員長情報反映ボタン disabled 管理
 */
'use strict'

/**
 * @classname CheckGetGroupCommitteeChairmanPossibility
 * @classdesc 団委員長情報反映ボタン disabled 管理
 */
export default class CheckGetGroupCommitteeChairmanPossibility {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.reflect-group-committee-chairman-wrap .group_id')
	 * @param {instance} controller
	 */
	constructor($e, controller) {
		console.log('CheckGetGroupCommitteeChairmanPossibility.constructor')
		this._$e = $e
		this._controller = controller
		this._$btnGetGroupCommitteeChairman = $('.btn-reflect-group-committee-chairman')
		this._$e.on('change', () => this.onChange())
		this._controller.on('revaluationGroup', () => this.onChange())
		this.onChange()
	}

	/**
	 * チェンジのコールバック
	 *
	 * @memberof CheckGetGroupCommitteeChairmanPossibility
	 * @return {undefined}
	 */
	onChange() {
		console.log('CheckGetGroupCommitteeChairmanPossibility.onChange')
		if (this._$e.val() !== '') this._$btnGetGroupCommitteeChairman.attr('data-group-id', this._$e.val())
		this._$btnGetGroupCommitteeChairman.prop('disabled', (this._$e.val() === ''))
	}
}
